import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { UserRole } from '../views/users/constant';

export const useGetWLDConfigs = () => {
  const { organization } = useSelector((state) => state.Organization);
  const { allBuildings } = useSelector((state) => state.building);
  const { roleId } = useSelector((state) => state.auth);

  const shouldShowLeakDetectors = useMemo(() => {
    if (roleId === UserRole.VENDOR) return false;

    // allBuildings is already scoped to buildings the user can access
    const anyAccessibleBuildingHasLeakDetectors = allBuildings?.some(
      (building) => building.config?.enable_leak_detectors
    );

    // Building managers (incl. multi-building): show if any accessible building has LDs
    if (roleId === UserRole.MANAGER) {
      return !!anyAccessibleBuildingHasLeakDetectors;
    }

    // Org managers and above: org flag or any accessible building
    return !!(
      organization?.config?.enable_leak_detectors || anyAccessibleBuildingHasLeakDetectors
    );
  }, [roleId, organization?.config, allBuildings]);

  return {
    shouldShowLeakDetectors
  };
};
